export const STUDENT_ACTIVITIES_EMPTY_STATE_MESSAGE =
  'Data will appear here if educators mark a Student Activity complete. Your school is not requiring Student Activities in its current implementation.'
